import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4"

class ConsultationRequestForm extends React.Component {
    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            input: {
                firstName: userExists ? props.location.state.user.firstname : '',
                lastName: userExists ? props.location.state.user.lastname : '',
                email: userExists ? props.location.state.user.email : '',
                phoneNumber: userExists ? props.location.state.user.phone : '',
                bestDay: moment().format('yyyy-MM-DD'),
                bestTime: '9am - 12 noon',
                typeOfRequest: (props.location.state) ? props.location.state.typeofrequest : 'Equipment Inquiry',
                username: userExists ? props.location.state.user.username : '',
                comments: ''
            },
            errors: {},
            loading: false
        };

        this.showButton = this.showButton.bind(this);

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["firstName"]) {
            isValid = false;
            errors["firstName"] = "Please enter your first name.";
        }
        if (!input["lastName"]) {
            isValid = false;
            errors["lastName"] = "Please enter your last name.";
        }

        if (!input["phoneNumber"] || !String(input["phoneNumber"])
            .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
            isValid = false;
            errors["phoneNumber"] = "Invalid phone number.";
        }

        if (!input["email"] || !String(input["email"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["email"] = "Invalid email address.";
        }
        if (!input["bestDay"]) {
            isValid = false;
            errors["bestDay"] = "Please choose a day.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }


    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }
    componentDidUpdate(event) {
        if (event.history.location.state && event.location.state.typeofrequest != event.history.location.state.typeofrequest) {
            let input = this.state.input;
            input.typeOfRequest = event.history.location.state.typeofrequest;
            this.setState({ input: input });
        }
    }
    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Request/consultation`, this.state.input).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'Consultation',
                    label: 'Consultation Request'
                });
                alert('Thank you for your request. A member of our team will be in touch soon!');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            alert('Error processing your request');
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    render() {
        return (
            <div>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='consultationRequest' /> : <GuestSiteMenu currentPage='consultationRequest' />)}
                <Form onSubmit={this.handleSubmit} noValidate>
                    <Row className="form-row-first">
                        <Form.Label style={{ marginBottom: '0px' }} className="form-header">Consultation Request Form</Form.Label>
                        <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>Provide contact info below and a member of our team will call to discuss options specialized for your needs.</Form.Label>

                        <Col md={6} xs={12}>
                            <Form.Group className="mb-3" controlId="formType">
                                <Form.Label>Consultation type</Form.Label>
                                <Form.Select name="typeOfRequest" value={this.state.input.typeOfRequest} onChange={this.handleFormChange}>
                                    <option key='blankChoice' hidden value="">Please choose one</option>
                                    <option value="Equipment Inquiry">Equipment Inquiry</option>
                                    <option value="Control Solutions">Control Solutions</option>
                                    <option value="Service Contract">Service Contract</option>
                                    <option value="Indoor Air Quality">Indoor Air Quality</option>
                                    <option value="Energy Optimization">Energy Optimization</option>
                                    <option value="Building Performance">Building Performance</option>
                                    <option value="Water Technologies">Water Technologies</option>
                                    <option value="Capital Asset Planning">Capital Asset Planning</option>
                                    <option value="Parts & Supplies Inventory Planning">Parts & Supplies Inventory Planning</option>
                                    <option value="HVAC System Design & Build">HVAC System Design & Build</option>
                                    <option value="Rental Services">Rental Services</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="firstName" value={this.state.input.firstName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.firstName} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="lastName" value={this.state.input.lastName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.lastName} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" name="email" value={this.state.input.email} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.email} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="phoneNumber" value={this.state.input.phoneNumber} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.phoneNumber} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.phoneNumber}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBestDay">
                                <Form.Label>Best day to reach you?</Form.Label>
                                <Form.Control type="date" min={moment().format('yyyy-MM-DD')} name="bestDay" value={this.state.input.bestDay} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.bestDay} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBestTime">
                                <Form.Label>Best time to reach you?</Form.Label>
                                <Form.Select name="bestTime" value={this.state.input.bestTime} onChange={this.handleFormChange}>
                                    <option value="9am - 12 noon">9am - 12 noon</option>
                                    <option value="12 noon - 3pm">12 noon - 3pm</option>
                                    <option value="3pm - 6pm">3pm - 6pm</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group style={{ marginLeft: 10, marginTop: -10, marginRight: 10 }} className="mb-3" controlId="formComments">
                        <Form.Label>Comments</Form.Label>
                        <Form.Control as="textarea" rows={3} name="comments" value={this.state.input.comments} onChange={this.handleFormChange} />
                    </Form.Group>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default ConsultationRequestForm;